/* ALNASHIR — GRID CARD ADD-TO-CART

   البطاقة القديمة كانت تستدعي Shopify.addItem() — دالة أزالها شوبيفاي
   منذ سنوات ضمن تقاعد AJAX API القديم. لذلك كانت الإضافة من
   المجموعات معطلة فعلياً بصمت — لا خطأ ظاهر، ولا دالة موجودة.

   هذا الملف يستبدلها بـ fetch('/cart/add.js') مباشرة، بنفس
   الأسلوب المستخدم في أشرطة الصفحة الرئيسية. */
(function () {
  if (window.__alnashirGridCard) return;
  window.__alnashirGridCard = true;

  function setLabel(btn, text) {
    var s = btn.querySelector('[data-agc-label]');
    if (s && text) s.textContent = text;
  }

  function syncCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll(
          '[data-cart-count], .cart-count-bubble span:first-child, .cart-count, #CartCount, .site-header__cart-count'
        );
        for (var i = 0; i < nodes.length; i++) {
          if (!/^\s*\d*\s*$/.test(nodes[i].textContent)) continue;
          nodes[i].textContent = cart.item_count;
        }
        ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
        });
      })
      .catch(function () {});
  }

  function addToCart(form, btn) {
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    btn.classList.add('is-loading');

    var original = btn.querySelector('[data-agc-label]');
    var originalText = original ? original.textContent : '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().catch(function () { return null; }).then(function (data) {
          if (!res.ok) throw new Error((data && (data.description || data.message)) || 'add_failed');
          return data;
        });
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        setLabel(btn, btn.dataset.addedText || 'Added');
        syncCartCount();
        setTimeout(function () {
          btn.classList.remove('is-done');
          setLabel(btn, originalText);
          btn.dataset.busy = '0';
        }, 1700);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setLabel(btn, btn.dataset.errorText || 'Try again');
        setTimeout(function () {
          btn.classList.remove('is-error');
          setLabel(btn, originalText);
          btn.dataset.busy = '0';
        }, 1900);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-agc-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-agc-add]');
    if (btn) addToCart(form, btn);
  });
})();
